import type { CartLine } from '@/api/models';
import { GarmentVisual } from '@/components/garment/GarmentVisual';

export function LineThumb({ line }: { line: Pick<CartLine, 'garment' | 'image'> }) {
  return (
    <GarmentVisual garment={line.garment} images={{ front: line.image, back: null }} hanger={false} decorative sizes="80px" />
  );
}
